document.querySelectorAll('.wp-block-tribe-blocks-product-compare').forEach((block) => {
    const container = block.querySelector('.table-wrapper');
    const content = block.querySelector('.table-wrapper table');
    const scrollbars = Array.from(block.querySelectorAll('.comparison-scrollbar')).map((scrollbar) => ({
        scrollbar,
        scroller: scrollbar.querySelector('.scrollbar-viewport'),
        inner: scrollbar.querySelector('.scrollbar-inner'),
        track: scrollbar.querySelector('.scrollbar-track'),
        thumb: scrollbar.querySelector('.scrollbar-thumb'),
        leftArrow: scrollbar.querySelector('.scrollbar-arrow-left'),
        rightArrow: scrollbar.querySelector('.scrollbar-arrow-right'),
    }));

    if (!container || !content || scrollbars.some(({ scroller, inner, track, thumb, leftArrow, rightArrow }) => !scroller || !inner || !track || !thumb || !leftArrow || !rightArrow)) {
        return;
    }

    const scrollByStep = (direction) => {
        const step = Math.max(container.clientWidth * 10, 120);

        container.scrollBy({
            left: step * direction,
            behavior: 'smooth',
        });
    };

    const updateScrollbar = ({ scrollbar, scroller, inner, track }) => {
        const scrollWidth = content.scrollWidth;
        const visibleWidth = container.clientWidth;
        const maxScroll = Math.max(scrollWidth - visibleWidth, 1);
        const trackWidth = track.clientWidth;
        const thumbWidth = Math.min(Math.max((visibleWidth / scrollWidth) * trackWidth, 24), trackWidth);
        const maxThumbOffset = Math.max(trackWidth - thumbWidth, 0);
        const thumbOffset = (container.scrollLeft / maxScroll) * maxThumbOffset;

        scrollbar.style.setProperty('--scrollbar-thumb-width', `${thumbWidth}px`);
        scrollbar.style.setProperty('--scrollbar-thumb-offset', `${thumbOffset}px`);
        scroller.scrollLeft = container.scrollLeft;
        inner.style.width = `${scrollWidth}px`;
    };

    const updateScrollbars = () => {
        scrollbars.forEach(updateScrollbar);
    };

    const scrollToPointer = ({ scroller, track, thumb }, event) => {
        const rect = track.getBoundingClientRect();
        const thumbWidth = thumb.offsetWidth;
        const targetOffset = event.clientX - rect.left - (thumbWidth / 2);
        const maxThumbOffset = Math.max(track.clientWidth - thumbWidth, 1);
        const scrollRatio = Math.max(0, Math.min(targetOffset / maxThumbOffset, 1));

        container.scrollLeft = scrollRatio * (content.scrollWidth - container.clientWidth);
        scroller.scrollLeft = container.scrollLeft;
        updateScrollbars();
    };

    scrollbars.forEach((scrollbarConfig) => {
        const { scroller, track, leftArrow, rightArrow } = scrollbarConfig;

        scroller.addEventListener('scroll', () => {
            container.scrollLeft = scroller.scrollLeft;
            updateScrollbars();
        });

        track.addEventListener('pointerdown', (event) => {
            event.preventDefault();
            scrollToPointer(scrollbarConfig, event);
            track.setPointerCapture(event.pointerId);
        });

        track.addEventListener('pointermove', (event) => {
            if (track.hasPointerCapture(event.pointerId)) {
                scrollToPointer(scrollbarConfig, event);
            }
        });

        track.addEventListener('pointerup', (event) => {
            if (track.hasPointerCapture(event.pointerId)) {
                track.releasePointerCapture(event.pointerId);
            }
        });

        leftArrow.addEventListener('click', () => scrollByStep(-1));
        rightArrow.addEventListener('click', () => scrollByStep(1));
    });

    container.addEventListener('scroll', updateScrollbars);
    window.addEventListener('load', updateScrollbars);
    window.addEventListener('resize', updateScrollbars);

    if ('ResizeObserver' in window) {
        new ResizeObserver(updateScrollbars).observe(content);
    }

    updateScrollbars();
});
